module.exports = __webpack_public_path__ + "static/media/message-bot.47b9549e.jpg";